"use client";

import { Lock } from "lucide-react";
import { designClass } from "@/dev-testbed/ui/design.ts";
import type { Sperrgrad } from "@/dev-testbed/testlauf/typen.ts";

type VorgabeHinweisProps = {
  id: string;
  sperre: Sperrgrad;
  hinweis?: string | null;
  /** Nur bei sperre === "vorschlag": Klick übernimmt den Wert */
  vorschlagWert?: string | null;
  onVorschlagUebernehmen?: (wert: string) => void;
};

const BADGE_TEXT: Record<Sperrgrad, string> = {
  hart: "Vom Test vorgegeben",
  weich: "Vorbelegt — Änderung wird protokolliert",
  vorschlag: "Vorschlag übernehmen",
};

/**
 * Badge unter/neben einem Feld mit aktiver Testvorgabe.
 * Kein reines Farbsignal — Text + bei hart Schloss-Symbol.
 */
export function VorgabeHinweis({
  id,
  sperre,
  hinweis,
  vorschlagWert,
  onVorschlagUebernehmen,
}: VorgabeHinweisProps) {
  const label = hinweis?.trim() || BADGE_TEXT[sperre];
  const istVorschlag = sperre === "vorschlag";

  if (istVorschlag && vorschlagWert && onVorschlagUebernehmen) {
    return (
      <button
        id={id}
        type="button"
        onClick={() => onVorschlagUebernehmen(vorschlagWert)}
        className={`${designClass.klein} mt-1 inline-flex items-center gap-1 text-[var(--text-muted)] underline-offset-2 hover:underline`}
      >
        {label}
      </button>
    );
  }

  return (
    <span
      id={id}
      className={`${designClass.klein} mt-1 inline-flex items-center gap-1 text-[var(--text-muted)]`}
    >
      {sperre === "hart" ? <Lock className="h-3 w-3 shrink-0" aria-hidden /> : null}
      {label}
    </span>
  );
}
